import styles from './index.module.sass';
import { useHistory } from 'react-router-dom';
import { useAppContext } from 'use-app';
import hint from 'images/hint_ok.svg';
import iconFb from 'images/icon_fb.svg';
import iconLine from 'images/icon_line.svg';
import classNames from 'classnames/bind';
import amplitude from 'service/amplitude';
import gaBridge from 'bridge/ga-bridge';
import { PATH, AUTOPASS_URL } from 'config';
import Button from 'components/button';
const cx = classNames.bind(styles);

const ShareDialog = ({ show, coupon, mobile, email, source, onClose }) => {
  const history = useHistory();
  const { setIsContinued } = useAppContext();
  const { attributes } = coupon;

  const shareLink = id => `${AUTOPASS_URL}/webview/coupons/${id}`;

  const KeepExchangeButton = ({ show = 'no' }) => {
    if (show !== 'yes') return <></>;

    return (
      <Button
        onClick={() => {
          setIsContinued(true);
          onClose();
          history.push({
            pathname: `${PATH.COUPON_OLD}/${coupon.id}`,
          });
        }}
      >
        繼續兌換優惠
      </Button>
    );
  };

  const DownloadButton = ({ show = 'yes' }) => {
    if (show === 'no') return <></>;
    return (
      <Button
        theme={attributes.keep_exchange_button_display === 'yes' ? 'yellow' : undefined}
        onClick={() => {
          window.open('https://autopass.app.link/EiAyDA1jD6');
        }}
      >
        立即下載車麻吉
      </Button>
    );
  };

  const ShareButton = ({ show = 'yes' }) => {
    if (show === 'no') return <></>;

    const fbTarget = window.innerWidth < 480 ? '_self' : '_blank';
    const fbHref =
      window.innerWidth < 480
        ? `fb-messenger://share/?link=${shareLink(coupon.id)}`
        : `https://www.facebook.com/sharer/sharer.php?u=${shareLink(coupon.id)}`;

    return (
      <>
        <div className={styles.shareContent}>
          <div className={`${styles.shareButton}`}>
            <a
              target={fbTarget}
              rel="noreferrer"
              href={fbHref}
              onClick={() => {
                gaBridge.logEvent('coupon_get_rewards', 'share', coupon.attributes.campaign);
                amplitude.shareOnClick('facebook', mobile, email, coupon, source);
              }}
            >
              <img src={iconFb} alt="fb-icon" />
            </a>
          </div>
          <div className={`${styles.shareButton}`}>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://social-plugins.line.me/lineit/share?url=${shareLink(coupon.id)}`}
              onClick={() => {
                gaBridge.logEvent('coupon_get_rewards', 'share', coupon.attributes.campaign);
                amplitude.shareOnClick('line', mobile, email, coupon, source);
              }}
            >
              <img src={iconLine} alt="line-icon" />
            </a>
          </div>
        </div>
        <div className={styles.shareText}>現在就分享限量優惠給好友</div>
      </>
    );
  };

  const maskClass = cx({
    mask: true,
    show,
  });

  return (
    <div
      className={maskClass}
      id="mask"
      onClick={e => {
        if (e.target.id === 'mask') onClose();
      }}
    >
      <div className={styles.content}>
        <div className={styles.closeBtn} onClick={onClose} />
        <div className={`${styles.hint}`}>
          <img src={hint} alt="hint" />
        </div>
        <div className={styles.title}>
          您已完成登錄
          <br />
          {attributes.download_button_display === 'yes' ? '立即下載領優惠！' : '立即交易領優惠！'}
        </div>
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{
            __html: attributes.share_content_first,
          }}
        ></div>
        <KeepExchangeButton show={attributes.keep_exchange_button_display} />
        <DownloadButton show={attributes.download_button_display} />
        <ShareButton show={attributes.share_button_display} />
      </div>
    </div>
  );
};

export default ShareDialog;
